import './_mobile-list.scss'

import { WithDefaultProps } from 'browser/components/atomic-elements/higher-order-components/with-default-props'
import { UIList } from 'browser/components/json-elements/atoms/list'

export const MobileList = WithDefaultProps(UIList, {
  className: 'mobile-list',
  addButtonClassName: 'mobile-list-add-button',
})
